import React from 'react';
import PropTypes from 'prop-types';
import {getModelForResourceType} from 'resources/modelRegistry';
import Markdown from 'components/Markdown/Markdown.react';

import {QuestionWrapper, HeadingBar} from '../shared/ContentBlocks.react';

const BlockedAssignmentQuestion = ({
  activeQuestion,
  activeQuestionSet,
  activeSubject,
  actions,
  navigateBackProps,
  navigateNextProps,
  headingActions
}) => (
  <QuestionWrapper
    question={activeQuestion}
    questionSet={activeQuestionSet}
    subject={activeSubject}
    heading={<HeadingBar />}
    navigateBackProps={navigateBackProps}
    navigateNextProps={navigateNextProps}
    headingActions={headingActions}
  >
    <Markdown
      text={`
[center]
## This question is not available
[/center]

This question is part of an active assignment, and is
not available for self-study. It will become available
once you have submitted the relevant assignments and are
able to access the explanations.
`}
    />
    <div className='u-mar-b_4' />
    {actions || null}
  </QuestionWrapper>
);

BlockedAssignmentQuestion.propTypes = {
  actions: PropTypes.node,
  activeQuestion: PropTypes.instanceOf(getModelForResourceType('question_v3')),
  activeQuestionSet: PropTypes.instanceOf(getModelForResourceType('question_set_v1')),
  activeSubject: PropTypes.instanceOf(getModelForResourceType('subject_v2')),
  navigateBackProps: PropTypes.shape({
    disabled: PropTypes.bool,
    handleNavigation: PropTypes.func
  }),
  navigateNextProps: PropTypes.shape({
    disabled: PropTypes.bool,
    handleNavigation: PropTypes.func
  }),
  headingActions: PropTypes.node
};

export default BlockedAssignmentQuestion;
